// parasm
// name:bug所属的项目
// isNetWork:是否需要发送当前网络

import { useNetwork } from '@vueuse/core'
const { isOnline, offlineAt, downlink, downlinkMax, effectiveType, saveData, type } = useNetwork()
import { useGlobalState } from '../plugins/vue/store';
const { state, initData } = useGlobalState()
// 加载一个脚本

function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    script.onload = function () {
        if (callback) callback();
    };

    document.head.appendChild(script);
}
function addNetWork(data) {
    data.network = {
        "isOnline": isOnline.value,
        'downlink': downlink.value,
        'effectiveType': effectiveType.value,
        'type': type.value,
        'offlineAt': offlineAt.value,
        'downlinkMax': downlinkMax.value,
        'saveData': saveData.value
    }
    return data
}

function addName(data) {
    data.activity = import.meta.env.VITE_NAME
    return data
}


// vue相关报错
export default function (data) {
    data = addName(data)
    if (data.isNetWork) {
        data = addNetWork(data)
    }
    console.error('注意！有错误', data)
    if (!window.UA) {
        try {
            loadScript('https://g20.gsf.netease.com/2025041501npm/tx_npm/20250415/UA.js', () => {
                const uap = new UAParser()
                window.UA = uap.getResult()
                data.ua = window.UA
                if (import.meta.env.PROD) {
                    fetch(`${import.meta.env.VITE_BASEAPI}/h5/common/record_frontend_log`, {
                        method: "POST",
                        body: JSON.stringify(data)
                    })
                }
            })


        } catch (e) {

        }
    } else {
        data.ua = window.UA
        if (import.meta.env.PROD) {
            fetch(`${import.meta.env.VITE_BASEAPI}/h5/common/record_frontend_log`, {
                method: "POST",
                body: JSON.stringify(data)
            })
        }
    }

}

export function logNoUa(data) {
    data = addName(data)
    if (data.isNetWork) {
        data = addNetWork(data)
    }
    console.log('报错了',data)
    if (import.meta.env.PROD) {
        fetch(`${import.meta.env.VITE_BASEAPI}/h5/common/record_frontend_log`, {
            method: "POST",
            body: JSON.stringify(data)
        })
    }
}


export function logPV(isLogin) {
    const headers = new Headers({});
    if (state.utm_source == 'gw' && state.extra == 'gw') {
        headers.set("Tx-Platform", state.utm_source)
    }
    if (state.extra !== 'gw') {
        headers.set("Tx-Platform", state.extra)
    }
    if (state.utm_source !== 'gw') {
        headers.set("Tx-Platform", state.utm_source)
    }

    let data = new FormData()
    data.append('activity', import.meta.env.VITE_NAME)
    data.append('op_code', 'login')
    data.append('details', JSON.stringify({ 'op_desc': "login" }))
    data.append('server_group', import.meta.env.VITE_TEAM == "tx2" ? 2 : 1)
    if (isLogin) {
        if (Object.keys(initData.role_info).length) {
            data.append('h5user_id', initData.role_info.role_id)
            data.append('role_name', initData.role_info.role_name)
            data.append('role_id', initData.role_info.role_id)
        }
        data.append('account_id', initData.account_data.username)
    } else {
        data.append('h5user_id', window.figureCode)
    }
    fetch(`${import.meta.env.VITE_BASEAPI}/h5/tx3/us/collect_log `, {
        method: "POST",
        body: data,
        headers:headers,
    })
}
